export default __webpack_public_path__ + "static/media/slots-hover.4093e54f.webp";